import React from "react";
import styled from "styled-components";
import { rel8Pink, rel8Purple, rel8White } from "../../globals";
import { mobile } from "../../responsive";

const BackDrop = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

const SubCon = styled.div`
  background-color: ${rel8White};
  
  height: 500px;
  border-radius: 10px;
  padding: 20px;
  overflow-y: auto;

  ${mobile({
    width: "250px",
  })}
`;
const SubConHeader = styled.p`
  font-weight: 700;
  text-align: center;
`;
const SubConBtnHold = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 20px;
`;
const SubConBtn = styled.input`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  color: ${(props) =>
    props.typex === "filled" ? `${rel8White}` : `${rel8Purple}`};
  cursor: pointer;
  background-color: ${(props) =>
    props.typex === "filled" ? `${rel8Purple}` : `${rel8Pink}`};
  /* background-color: ${(props) =>
    props.loading === "loading" ? "#d3d3d3" : ""}; */
`;


const CustomModal = ({children,title,close,modalWith='350px'})=>{

    return (
        <BackDrop >
            <style>
            {`
            body{
            overflow:hidden;
            }
            `}
            </style>
            <SubCon style={{'width':modalWith}}>
          <SubConHeader
          style={{'position':'relative'}}
          >{title}
          
              <SubConBtn 
              style={{'position':'absolute','right':'0'}}
                type={"submit"}
                value="Cancel"
                onClick={close}
              />
          </SubConHeader>

            <br />
            {children}

            <SubConBtnHold>

              <SubConBtn
                type={"submit"}
                value="Cancel"
                onClick={close}
              />
            </SubConBtnHold>
        </SubCon>

        </BackDrop>
    )
}

export default CustomModal